module.exports = __webpack_public_path__ + "img/aspx.586b0d75.svg";